import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {WeightedCardScratchpadState} from '../../scratchpad/weightedCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setShouldSplitAudienceInputSchema = z.object({
  shouldSplitAudience: z
    .boolean()
    .describe(
      'Enable Audience Split for manual A/B testing when you need distinct user groups exposed to only one output each.',
    ),
});

export default function setShouldSplitAudienceTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof setShouldSplitAudienceInputSchema,
      WeightedCardScratchpadState
    >,
  ) {
    const {shouldSplitAudience} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<WeightedCardScratchpadState>(
      agentScratchpad,
      NodeType.WEIGHTED,
    );

    validatedScratchpad.card.shouldSplitAudience = shouldSplitAudience;

    return toolResult(
      `Audience split ${shouldSplitAudience ? 'enabled' : 'disabled'} successfully`,
    );
  }

  return tool<typeof setShouldSplitAudienceInputSchema, WeightedCardScratchpadState>({
    name: V2CardAgentToolName.SetShouldSplitAudience,
    displayName: 'Setting audience split',
    description:
      'Enable Audience Split for manual A/B testing when you need distinct user groups exposed to only one output each.',
    inputSchema: setShouldSplitAudienceInputSchema,
    execute,
  });
}
